import { bindCitationPresentation, isPreparedCitation } from './citationBindings.js';
const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);const CITATION_HIT_SCORE_THRESHOLD = 0.05;

function hasRenderableCitation(citation = {}) {
  if (citation.evidence_admission || citation.citation_target || citation.reading) return isPreparedCitation(citation);
  const score = Number(Object(citation).score);
  if (Number.isFinite(score)) {
    return score >= CITATION_HIT_SCORE_THRESHOLD;
  }
  const matchedText = String(Object(citation).matched_text || Object(citation).hit_reason || '').trim();
  if (matchedText.length >= 2) {
    return true;
  }
  const snippet = String(Object(citation).snippet || '').trim();
  return snippet.length >= 12;
}

export function normalizeCitationPayload(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }
  const citations = Array.isArray(payload.citations) ? payload.citations : [];
  const filtered = citations.filter((citation) => hasRenderableCitation(citation));
  if (filtered.length === 0 && !payload.conversation_projection) {
    return null;
  }
  return {
    ...payload,
    citations: filtered,
  };
}

function formatCitationLine(citation = {}, index = 0) {
  const citationId = String(firstTruthy(() => (Object(citation).citation_id), () => (`cite_${index + 1}`))).trim();
  const title = String(firstTruthy(() => (Object(citation).title), () => (Object(citation).source_id), () => (''))).trim();
  const snippet = String(firstTruthy(() => (Object(citation).snippet), () => (Object(citation).matched_text), () => (Object(citation).hit_reason), () => (''))).trim();
  const score = Number(Object(citation).score);
  const sourceUrl = String(firstTruthy(() => (Object(citation).url), () => (Object(citation).source_url), () => (''))).trim();
  const scoreSuffix = Number.isFinite(score) ? ` (${score.toFixed(2)})` : '';
  const detailText = snippet ? `：${snippet}` : '';
  const linkText = sourceUrl ? `\n${sourceUrl}` : '';
  return `[${citationId}] ${title}${scoreSuffix}${detailText}${linkText}`.trim();
}

function buildCitationAppendix(payload) {
  if (!payload || !Array.isArray(payload.citations) || payload.citations.length === 0) {
    return '';
  }
  const lines = payload.citations
    .map((citation, index) => formatCitationLine(citation, index))
    .filter(Boolean);
  if (lines.length === 0) {
    return '';
  }
  return lines.join('\n\n');
}

export function mergeAssistantContentWithCitation(content, citationPayload) {
  void buildCitationAppendix;
  return bindCitationPresentation(content, citationPayload).content;
}
